export default __webpack_public_path__ + "static/barasti-94c640ec6edb69828ec1801331bd7963.webp";